import { render, staticRenderFns } from "./ButtonConfirm.vue?vue&type=template&id=3b778ee2&"
import script from "./ButtonConfirm.vue?vue&type=script&lang=js&"
export * from "./ButtonConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ButtonConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports